import { apiNiches } from "@/common/services";
import { showNotification } from "@/components/notifications/Notifications";

export const updateNiches = async (gifId: string, selected: string[], onSuccess: () => void) => {
  try {
    await apiNiches.removeGifNiches({ gifId, nicheIds: selected });
    showNotification({
      variant: "success",
      title: "Gif niches updated."
    });
    onSuccess();
  } catch (e) {
    console.error(`Could not set gif niches: ${e}`);
    showNotification({
      variant: "error",
      title: "Could not save niches, please try again."
    });
  }
};
